import { useState } from "react";import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";
import { Leaf, ArrowRight } from "lucide-react";
import { toast } from "sonner";

const BG = "https://images.unsplash.com/photo-1779609134940-5028533d010e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHw0fHwlMjJlbGVnYW50JTIwaXRhbGlhbiUyMHJlc3RhdXJhbnQlMjBpbnRlcmlvciUyMGJyaWdodCUyMnxlbnwwfHx8fDE3ODYwMDgzNDF8MA&ixlib=rb-4.1.0&q=85";

export default function Login() {
  const { login, register } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [mode, setMode] = useState(params.get("mode") === "register" ? "register" : "login");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      if (mode === "login") await login(email, password);
      else await register(email, password, name || "Utente");
      toast.success("Accesso effettuato");
      navigate("/");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#FAFAF9]">
      <div className="flex items-center justify-center p-8 sm:p-16 relative noise-overlay">
        <div className="w-full max-w-sm animate-fade-in-up">
          <div className="flex items-center gap-2 mb-12">
            <div className="w-9 h-9 rounded-sm bg-brand flex items-center justify-center">
              <Leaf className="text-white" size={18} strokeWidth={1.5} />
            </div>
            <span className="font-serif text-2xl text-stone-900 tracking-tight">Q<span className="text-brand">COST</span></span>
          </div>

          <h1 className="font-serif text-4xl sm:text-5xl font-light tracking-tight text-stone-900 mb-2">
            {mode === "login" ? "Bentornato" : "Crea il tuo account"}
          </h1>
          <p className="text-sm text-stone-500 mb-10">
            Controlla i costi dei fornitori e l'incidenza sulle vendite.
          </p>

          <form onSubmit={submit} className="space-y-5">
            {mode === "register" && (
              <div>
                <label className="text-xs uppercase tracking-[0.15em] font-bold text-stone-500">Nome</label>
                <input data-testid="register-name-input" value={name} onChange={(e) => setName(e.target.value)}
                  className="mt-2 w-full border border-stone-300 bg-white px-4 py-3 text-sm rounded-sm outline-none focus:ring-2 focus:ring-brand/40 transition-colors" placeholder="Il tuo nome" />
              </div>
            )}
            <div>
              <label className="text-xs uppercase tracking-[0.15em] font-bold text-stone-500">Email</label>
              <input data-testid="login-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                className="mt-2 w-full border border-stone-300 bg-white px-4 py-3 text-sm rounded-sm outline-none focus:ring-2 focus:ring-brand/40 transition-colors" placeholder="nome@ristorante.it" />
            </div>
            <div>
              <label className="text-xs uppercase tracking-[0.15em] font-bold text-stone-500">Password</label>
              <input data-testid="login-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                className="mt-2 w-full border border-stone-300 bg-white px-4 py-3 text-sm rounded-sm outline-none focus:ring-2 focus:ring-brand/40 transition-colors" placeholder="••••••••" />
              {mode === "login" && (
                <button type="button" data-testid="forgot-password-link" onClick={() => navigate("/forgot-password")}
                  className="mt-2 text-xs text-stone-500 hover:text-brand hover:underline">Password dimenticata?</button>
              )}
            </div>

            {error && <p data-testid="login-error" className="text-sm text-alert">{error}</p>}

            <button data-testid="login-submit-btn" disabled={loading}
              className="group w-full rounded-full bg-brand text-white py-3.5 text-sm font-semibold flex items-center justify-center gap-2 hover:bg-brand-hover transition-colors disabled:opacity-60">
              {loading ? "Attendere…" : mode === "login" ? "Accedi" : "Registrati"}
              <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
            </button>
          </form>

          <p className="mt-8 text-sm text-stone-500">
            {mode === "login" ? "Non hai un account? " : "Hai già un account? "}
            <button data-testid="toggle-auth-mode" onClick={() => { setMode(mode === "login" ? "register" : "login"); setError(""); }}
              className="text-brand font-semibold hover:underline">
              {mode === "login" ? "Registrati" : "Accedi"}
            </button>
          </p>
        </div>
      </div>

      <div className="hidden lg:block relative">
        <img src={BG} alt="Sala ristorante elegante" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-brand-hover/70 via-transparent to-transparent" />
        <div className="absolute bottom-12 left-12 right-12 text-white">
          <p className="font-serif text-3xl font-light leading-snug">
            "Il vero controllo di gestione inizia dalla fattura del fornitore."
          </p>
        </div>
      </div>
    </div>
  );
}
